import React from 'react';
import './Header.css';

function Header({ onAdminClick }) {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <div className="logo">
            <img src="/logo.png" alt="Amachi Sangli Logo" className="logo-image" />
            <div className="logo-text">
              <h1>Amachi Sangli</h1>
              <p>Business Directory</p>
            </div>
          </div>
        </div>
        <div className="header-right">
          <div className="location-info">
            <span className="location-icon">📍</span>
            <span>Sangli, Maharashtra</span>
          </div>
          {onAdminClick && (
            <button className="admin-button" onClick={onAdminClick} title="Admin Panel">
              🔐
            </button>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
